module.exports = __webpack_public_path__ + "img/drug_enforcement-detail.b03a66f3.jpg";